import React from 'react';
import { Button, Rate } from 'antd';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import { formatDateFromNow } from 'utils/textUtils';

import logoKindi from 'assets/images/kindi-logo.png';
import logoGoogle from 'assets/images/google-logo.png';
import { HeartFilled } from '@ant-design/icons';
import { ActionCommentStyles, HeaderCommentStyles } from './styles';

const HeaderComment = ({
  authorName,
  rating,
  createdAt,
  isInternalRating,
  isShowRate,
  isShowLogo,
  isRecommended,
}) => (
  <HeaderCommentStyles className="header-comment-item">
    <div className="title-header flex items-center">
      <div className="name-rating">
        <span className="name-user">
          {authorName || i18next.t('error.waitingUpdate')}
        </span>
        {isShowRate && <Rate disabled allowHalf value={rating} />}
      </div>
      <ActionCommentStyles className="flex items-center">
        {isRecommended && (
          <Button className="recommend-button" icon={<HeartFilled />}>
            {i18next.t('button.recommend')}
          </Button>
        )}

        {isShowLogo && (
          <img
            className="image-logo ml-6"
            src={isInternalRating ? logoKindi : logoGoogle}
            alt=""
          />
        )}
      </ActionCommentStyles>
    </div>

    <div className="time-comment">{formatDateFromNow(createdAt)}</div>
  </HeaderCommentStyles>
);

HeaderComment.propTypes = {
  authorName: PropTypes.string,
  rating: PropTypes.number,
  createdAt: PropTypes.string,
  isInternalRating: PropTypes.bool,
  isShowRate: PropTypes.bool,
  isShowLogo: PropTypes.bool,
  isRecommended: PropTypes.bool,
};

HeaderComment.defaultProps = {
  isShowRate: true,
  isShowLogo: true,
};

export default HeaderComment;
